import { Colors } from 'design/colors'

const ErrorPage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Colors.DARK_GREEN,
        color: Colors.WHITE,
        height: '100vh',
        width: '100vw'
      }}
    >
      <p style={{ fontSize: '24px', fontWeight: 'bold' }}>Sorry, something went wrong</p>
      <p style={{ marginTop: '10px', fontSize: '18px' }}>
        Go back to{' '}
        <a
          href="/"
          style={{
            color: Colors.WHITE,
            textDecoration: 'underline'
          }}
        >
          Home
        </a>
      </p>
    </div>
  )
}

export default ErrorPage
